/*
  MSNQ section ids
 */

export default [
  'question01',
  'question02',
  'question03',
  'question04',
  'question05',
  'question06',
  'question07',
  'question08',
  'question09',
  'question10',
  'question11',
  'question12',
  'question13',
  'question14',
  'question15',
];
